import { Stack } from "@mui/material";
import { Task } from "src/api/types";
import SubmitOrder from "src/components/SubmitOrder";
import PrescriptionProvider from "src/context/PrescriptionProvider";
import TaskWrapper from "src/wrappers/TaskWrapper";

interface Props {
  task: Task;
  onSuccess: () => Promise<void>;
}

const SubmitOrderTask = ({ task, onSuccess }: Props) => {
  return (
    <PrescriptionProvider prescriptionId={task.resource_id}>
      <Stack gap={2}>
        <TaskWrapper task={task}>
          <SubmitOrder onSuccess={onSuccess} />
        </TaskWrapper>
      </Stack>
    </PrescriptionProvider>
  );
};

export default SubmitOrderTask;
